import type {Schemas} from 'api/dto.generated';

const dto: Schemas.WorkFlattenedDto = {
  work: {
    id: '023db249-f98d-4272-be8b-649b6dd33042',
    created: 1732626338771,
    modified: 1732705315486,
    type: 'BOOK',
    preferredTitle: ['Tangenter'],
    languages: ['nob'],
    agents: [
      {
        roles: ['B01'],
        agentId: 'a1dc23ba-70f7-494b-976b-c5c6657ce6d0',
        agentType: 'PERSON',
        agentName: {
          id: '9d475f87-8664-45e4-96f4-3fd35aa4f5a1',
          name: 'Maren',
          surName: 'Ørstavik',
          nameOrder: 0,
        },
        nationalId: '1576134001725',
      },
    ],
    dewey: [],
    intellectualLevel: ['15'],
    literatureType: ['10'],
    themes: ['AVP', 'AVRG1', 'DNBF'],
    subjects: ['emneord_musikere', 'emneord_piano'],
    genreAndForm: [
      'https://id.nb.no/vocabulary/ntsf/81',
      'https://id.nb.no/vocabulary/ntsf/36',
    ],
    norwegianSubjects: [
      'https://id.nb.no/vocabulary/neo/3118',
      'https://id.nb.no/vocabulary/neo/3733',
    ],
    bibleContent: [],
    seriesRelations: [],
    workRelations: [],
    agentRelations: [],
    prizes: [],
  },
  expressions: [
    {
      id: '66bb1488-d1a7-4336-bd73-22ffdbe19bcd',
      workId: '023db249-f98d-4272-be8b-649b6dd33042',
      created: 1732626338772,
      modified: 1732704928924,
      expressionFormat: 'ILLUSTRATED_TEXT',
      languages: ['nob'],
      content: [],
      agents: [],
    },
  ],
  manifestations: [
    {
      id: 'bf41ad51-478e-46e2-86b9-aeef28b75418',
      expressionId: '66bb1488-d1a7-4336-bd73-22ffdbe19bcd',
      created: 1732626338766,
      modified: 1732705315819,
      registered: 1732626338766,
      status: 'COMPLETED',
      isbn: '9788278533383',
      ean: '9788278533383',
      wrongIsbn: [],
      publishedYear: 2024,
      pageCount: '150',
      contentReceivedDate: '2024-11-26',
      completedDate: '2024-11-27',
      productForm: 'BC',
      productFormDetail: [],
      physicalProperties: [],
      bookGroup: '226',
      productGroup: '38030',
      externalSystemInfo: {
        ids: [],
        created: undefined,
        modified: undefined,
      },
      titleInfo: {
        mainTitles: [
          {
            subTitles: [
              {
                parallelTitles: [],
                value: 'pianister om pianister',
                order: 0,
              },
            ],
            parallelTitles: [],
            value: 'Tangenter',
            order: 0,
          },
        ],
        otherTitles: [],
      },
      editionType: [],
      seriesRelations: [
        {
          entityId: '9fac029a-3dfe-4f9a-b080-6f025a2ccce2',
          role: 'PART_OF',
          type: 'PUBLISHER_SERIES',
          title: 'NMH-publikasjoner',
          numberInSeries: '2024:3',
          allTitles: [
            {
              value: 'NMH-publikasjoner',
              language: 'nob',
            },
            {
              value: 'NMH-publikasjoner',
              language: 'eng',
            },
          ],
        },
      ],
      imprints: [
        {
          agentId: '4e235c87-4e7d-40d9-8507-e01663e14f37',
          agentName: {
            id: 'ff8ffacb-4522-44f4-b383-3f7c2b05900e',
            name: 'Norges musikkhøgskole',
            nameOrder: 0,
          },
          place: 'Oslo',
        },
      ],
      productOwners: [
        {
          code: '4293',
          name: 'Norges Musikkhøgskole',
        },
      ],
      marketingData: {
        products: [
          {
            owner: '4293',
            distributor: 'EGEN',
            status: 'ACTIVE',
            publisherSalesDate: '2024-11-26',
            inSaleDate: '2024-11-26',
            comingDate: undefined,
            measures: [
              {
                type: 'WEIGHT',
                value: '300',
                unit: 'GRAM',
              },
              {
                type: 'HEIGHT',
                value: '205',
                unit: 'MM',
              },
              {
                type: 'THICKNESS',
                value: '11',
                unit: 'MM',
              },
              {
                type: 'WIDTH',
                value: '170',
                unit: 'MM',
              },
            ],
            descriptions: [
              {
                content:
                  'Essaysamlingen <em>Tangenter. Pianister om pianister</em> samler åtte biografier om kjente pianister, både nålevende og avdøde.<br><br>Innhold i boken<br>Liv i musikken. <em>Jorunn Marie Bratlie i samtale med Liv Glaser</em><br>Mannen med gulltipsene. <em>Ingrid Røynesdal om Jens Harald Bratlie</em><br>Profeten. <em>Magnus Andersson om Håkon Austbø</em><br>Eva – minner om en stjerne. <em>Einar Steen-Nøkleberg om Eva Knardahl</em><br>Svermer og petimeter. <em>Olaf Eggestad om Robert Riefling</em><br>Møtet. <em>Eyolf Dale om Misha Alperin. </em>Les hele kapitlet nedenfor.<br>Pianisten og pedagogen. <em>Håvard Gimse i samtale med Jiři Hlinka</em><br>Performing Precarity. <em>Ellen Ugelvik om Klaveret</em><br><br>Bakgrunn<br>I matematikken er en tangent en linje som berører en sirkel eller en kurve i et punkt. På klaveret er tangenten «knappen» pianisten berører for å lage lyd. Begge betydningene handler om berøring, om møter.<br>Denne boken tar for seg møter mellom norske pianister og forsøker å belyse hvordan disse møtene har preget utøversituasjonen i Norge i dag. Boka er en del av Norges musikkhøgskoles historieprosjekt. Les mer om prosjektet på Musikkhøgskolens nettsider.<br><br>Om redaktøren<br>Maren Ørstavik (f. 1986) er musikkritiker, journalist og forfatter. Hun er utdannet pianist fra Norges musikkhøgskole og har jobbet som musikkritiker i Aftenposten siden 2014. I tillegg frilanser hun som kulturjournalist for en rekke tidsskrifter og magasiner og har utgitt flere barnebøker på Aschehoug forlag.<br>',
                language: 'nob',
                agentId: undefined,
                type: 'HTML',
              },
              {
                content:
                  'Essaysamlingen Tangenter. Pianister om pianister samler åtte biografier om kjente pianister, både nålevende og avdøde.Innhold i bokenLiv i musikken. Jorunn Marie Bratlie i samtale med Liv GlaserMannen med gulltipsene. Ingrid Røynesdal om Jens Harald BratlieProfeten. Magnus Andersson om Håkon AustbøEva – minner om en stjerne. Einar Steen-Nøkleberg om Eva KnardahlSvermer og petimeter. Olaf Eggestad om Robert RieflingMøtet. Eyolf Dale om Misha Alperin. Les hele kapitlet nedenfor.Pianisten og pedagogen. Håvard Gimse i samtale med Jiři HlinkaPerforming Precarity. Ellen Ugelvik om KlaveretBakgrunnI matematikken er en tangent en linje som berører en sirkel eller en kurve i et punkt. På klaveret er tangenten «knappen» pianisten berører for å lage lyd. Begge betydningene handler om berøring, om møter.Denne boken tar for seg møter mellom norske pianister og forsøker å belyse hvordan disse møtene har preget utøversituasjonen i Norge i dag. Boka er en del av Norges musikkhøgskoles historieprosjekt. Les mer om prosjektet på Musikkhøgskolens nettsider.Om redaktørenMaren Ørstavik (f. 1986) er musikkritiker, journalist og forfatter. Hun er utdannet pianist fra Norges musikkhøgskole og har jobbet som musikkritiker i Aftenposten siden 2014. I tillegg frilanser hun som kulturjournalist for en rekke tidsskrifter og magasiner og har utgitt flere barnebøker på Aschehoug forlag.',
                language: 'nob',
                agentId: undefined,
                type: 'PLAINTEXT',
              },
            ],
            hidden: false,
            publisherStatus: '04',
            distributorStatus: '20',
          },
        ],
      },
      statementOfResponsibility: 'redigert av Maren Ørstavik',
      autoGenerateStatementOfResponsibility: true,
      trykkunderlagData: {
        willNotBeDelivered: false,
      },
    },
  ],
};

export default dto;
